import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c38463a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_3 = { class: "flex flex-col items-start font-montserrat" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex text-sm text-gray-500" }
const _hoisted_6 = { class: "mt-4 flex flex-col justify-center" }
const _hoisted_7 = { class: "flex items-center justify-center m-auto" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center m-auto mb-4"
}
const _hoisted_9 = { class: "rounded-xl shadow-md myMatchesClue w-[580px] sm:w-[320px] flex flex-col gap-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full !border my-2 rounded-full border-gray-500" }, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "mt-8 flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MatchBookingAvailability = _resolveComponent("MatchBookingAvailability")!

  return (_ctx.bookingsDataSource.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTittle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('do_you_prefer_to_set_up_your_own_match')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('play_your_way')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingsDataSource, (book) => {
            return (_openBlock(), _createElementBlock("div", {
              key: book.tenant.id
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MatchBookingAvailability, {
                  book: book,
                  date: _ctx.filteredDataToSend.date,
                  allowShowMore: _ctx.allowShowMore,
                  onHourSelected: _ctx.hourSelected
                }, null, 8, ["book", "date", "allowShowMore", "onHourSelected"])
              ])
            ]))
          }), 128)),
          (_ctx.showCreateMatch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t("do_you_have_a_court")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createMatchNotInTaykus && _ctx.createMatchNotInTaykus(...args))),
                    class: "walletButton p-2 md:min-w-[364px] mx-auto"
                  }, _toDisplayString(_ctx.$t("i_allready_have_a_court")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
        (_ctx.showNoResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('no_results')), 1))
          : _createCommentVNode("", true)
      ]))
}